export const handleWidth: IHandleWidth = 
(
  isTablet,
  isLarge,
  isXLarge
) => {
  if (isXLarge) return "32rem";
  if (isLarge) return "24rem";
  if (isTablet) return "100%";

  return "calc(38.5% - 1.5rem)";
};


type IHandleWidth = (
    isTablet:boolean, 
    isLarge:boolean, 
    isXLarge:boolean, 
) => string
